import React from 'react'
import Heading from '../components/Heading'
import rizal from '../images/rizal-prof.svg'
import lightthree from '../images/light3desk.webp'
import lightfour from '../images/light4desk.svg'
import rzlfh from '../images/rzlfh-icon.svg'
import Experience from '../components/Experience'
import { HiOutlineMail, HiOutlinePhone } from "react-icons/hi";
import ScrollToTop from '../components/ScrollToTop'
import { motion } from "framer-motion"
import { useInView } from 'react-intersection-observer'
import { useEffect } from 'react'
import { useAnimation } from 'framer-motion'

const Resume = () => {

    const { ref, inView } = useInView();

    const animation = useAnimation();
    const animation2 = useAnimation();
    const animation3up = useAnimation();


    useEffect(() => {
        if (inView) {
            animation.start({
                x: 0,
                opacity: 1,
                transition: {
                    ease: [0.6, 0.01, -0.05, 0.95],
                    duration: 1,
                    delay: 0.4,
                }
            });

            animation2.start({
                x: 0,
                opacity: 1,
                transition: {
                    ease: [0.6, 0.01, -0.05, 0.95],
                    duration: 1,
                    delay: 0.8,
                }
            });

            animation3up.start({
                y: 0,
                opacity: 1,
                transition: {
                    ease: [0.6, 0.01, -0.05, 0.95],
                    duration: 1,
                    delay: 0.4,
                }
            });
        }
        if (!inView) {
            animation.start({
                x: -30,
                opacity: 0,
            });

            animation2.start({
                x: -30,
                opacity: 0,
            });

            animation3up.start({
                y: -60,
                opacity: 0,
            });
        }
    }, [inView]);

    return (
        <>
            <div className='relative -z-[5]'>
                <img src={lightthree} alt="light 1" className='absolute top-0 left-0 w-[70%] md:w-[40%] -z-10' />

                <motion.main
                    className='px-8 md:px-[7.875em] lg:px-0 grid place-content-center lg:grid-cols-6 text-center lg:text-left py-4 space-y-8 lg:space-y-4'>
                    <section className='lg:col-start-2 lg:col-end-6 lg:grid lg:grid-cols-4'>

                        <div className='mt-[14em] lg:col-start-1 lg:col-end-5 lg:grid lg:grid-cols-4'>
                            <Heading text="About Me" />
                            <motion.img
                                initial={{ opacity: 0, y: 30 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{
                                    ease: [0.6, 0.01, -0.05, 0.95],
                                    duration: 1,
                                    delay: 0.4,
                                }}
                                src={rizal} alt="rizal-pic" className='mx-auto mb-8 lg:mb-0 lg:col-start-1 lg:col-end-2 lg:w-[100%] lg:justify-center lg:px-4' />
                            <div className='text-center lg:text-left lg:col-start-2 lg:col-end-5 lg:ml-8'>
                                <motion.p
                                    initial={{ opacity: 0, x: 30 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{
                                        ease: [0.6, 0.01, -0.05, 0.95],
                                        duration: 1,
                                        delay: 0.6,
                                    }}>
                                    I’m a fresh graduate from Universitas Kristen Satya Wacana majoring in Information Technology with a GPA of 3.61, currently based in Salatiga, Indonesia. I’m really into UI/UX design, front end development, graphic design & digital illustration
                                </motion.p>
                                <motion.div
                                    initial={{ opacity: 0, x: 30 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{
                                        ease: [0.6, 0.01, -0.05, 0.95],
                                        duration: 1,
                                        delay: 0.8,
                                    }}
                                    className='mt-6'>
                                    <ul className=''>
                                        <li className='flex items-center gap-4 justify-center lg:justify-start'><HiOutlineMail />rizalfahadian7@gmail.com</li>
                                        <li className='flex items-center gap-4 justify-center lg:justify-start'><HiOutlinePhone />+6281572453165</li>
                                    </ul>
                                </motion.div>
                            </div>

                        </div>

                        <div className='text-left mt-[9em] lg:col-start-1 lg:col-end-5 lg:grid lg:grid-cols-4'>
                            <Heading text="Experience" />
                            <Experience
                                tgl="February 2021 - May 2021"
                                company="Institut Tata Kelola dan Manajemen Teknologi Informasi UKSW"
                                role="Front End Developer Intern"
                                task1="Worked alongside another developer to built website from one of the foundations for recording alumni data that was previously inputted manually."
                                task2="Designed and built a website interface from design stage to the development stage."
                                task3="Tools: Bootstrap, Laravel, PHP MySQL, VS Code."
                            />
                            <Experience
                                tgl="September 2020 - December 2020"
                                company="Institut Tata Kelola dan Manajemen Teknologi Informasi UKSW"
                                role="UI Designer Intern"
                                task1="Worked with app developers to build social culture applications based on android apps."
                                task2="Designed UI, UX and materials for 4 android apps."
                                task3="Tools: Figma, Adobe Illustrator, Android Studio."
                            />
                        </div>

                        <div className='text-left mt-[9em] lg:mt-[5em] lg:col-start-1 lg:col-end-5 lg:grid lg:grid-cols-4'>
                            <Heading text="Education" />
                            <Experience
                                tgl="2017 - 2021"
                                company="Universitas Kristen Satya Wacana"
                                role=" Teknik Informatika"
                                task1="Cumulative GPA: 3.61"
                                task2="Concentration: Application Development."
                                task3="Relevant Courses: Android App & Web Development, Data Structures & Algorithm, Software Design Methodology, Project Management."
                            />
                        </div>

                        <div ref={ref} className='text-left mt-[9em] lg:mt-[5em] lg:col-start-1 lg:col-end-5 lg:grid lg:grid-cols-4'>
                            <Heading text="Skills" />

                            <motion.div
                                animate={animation}
                                className='flex justify-between w-[90%] md:w-[50%] lg:w-[100%] mx-auto lg:mx-0 mb-8 lg:mb-0 gap-8 lg:gap-0 lg:col-start-1 lg:col-end-3 lg:grid lg:grid-cols-2'>
                                <ul
                                    className='lg:col-start-1 lg:col-end-2 lg:space-y-[1.06em]'>
                                    <li className='text-[1.05em] font-[600]'>HTML, CSS, JS</li>
                                    <li className='text-[1.05em] font-[600]'>Sass</li>
                                    <li className='text-[1.05em] font-[600]'>Tailwind Css</li>
                                    <li className='text-[1.05em] font-[600]'>React JS</li>
                                </ul>

                                <ul className='lg:col-start-2 lg:col-end-3 lg:space-y-[1.06em]'>
                                    <li className='text-[1.05em] text-[#A1A1A1]'>Intermediate</li>
                                    <li className='text-[1.05em] text-[#A1A1A1]'>Intermediate</li>
                                    <li className='text-[1.05em] text-[#A1A1A1]'>Intermediate</li>
                                    <li className='text-[1.05em] text-[#A1A1A1]'>Beginner</li>
                                </ul>
                            </motion.div>

                            <motion.div
                                animate={animation2}
                                className='flex justify-between w-[90%] md:w-[50%] lg:w-[100%] mx-auto lg:mx-0 gap-8 lg:gap-0 lg:col-start-3 lg:col-end-5 lg:grid lg:grid-cols-2'>
                                <ul className='lg:col-start-1 lg:col-end-2 lg:space-y-[1.06em]'>
                                    <li className='text-[1.05em] font-[600]'>UI/UX Design</li>
                                    <li className='text-[1.05em] font-[600]'>Responsive Design</li>
                                    <li className='text-[1.05em] font-[600]'>Figma</li>
                                    <li className='text-[1.05em] font-[600]'>Adobe Illustrator</li>
                                </ul>

                                <ul className='lg:col-start-2 lg:col-end-3 lg:space-y-[1.06em]'>
                                    <li className='text-[1.05em] text-[#A1A1A1]'>Intermediate</li>
                                    <li className='text-[1.05em] text-[#A1A1A1]'>Intermediate</li>
                                    <li className='text-[1.05em] text-[#A1A1A1]'>Advanced</li>
                                    <li className='text-[1.05em] text-[#A1A1A1]'>Advanced</li>
                                </ul>
                            </motion.div>

                        </div>

                    </section>
                </motion.main>
            </div>

            <ScrollToTop />

            <div className='relative'>
                <motion.footer ref={ref}
                    animate={animation3up}
                    className='px-4 md:px-[7.875em] flex items-center justify-between  text-center py-8'>
                    <img src={rzlfh} alt="rzlfh" className=' hidden md:block animate-spin-slow' />
                    <ul className='flex items-center space-x-14 md:space-x-8 text-center  mx-auto md:mx-0'>
                        <li><a href="https://www.instagram.com/rzlfh/" className='underline opacity-70 hover:opacity-100 ' target="_blank">Instagram</a></li>
                        <li><a href="https://www.linkedin.com/in/rizal-fahadian-281b571b1/" className='underline opacity-70 hover:opacity-100' target="_blank">LinkedIn</a></li>
                        <li><a href="https://github.com/rzlfhh" className='underline opacity-70 hover:opacity-100' target="_blank">Github</a></li>
                    </ul>
                </motion.footer>

                <div className='absolute bottom-0 right-0 flex justify-end w-[70%] md:w-[40%] -z-10'>
                    <img src={lightfour} alt="light 1" />
                </div>
            </div>

        </>
    )
}

export default Resume
